import { render, staticRenderFns } from "./WidgetHome.vue?vue&type=template&id=3ffb6ea0&"
import script from "./WidgetHome.vue?vue&type=script&lang=js&"
export * from "./WidgetHome.vue?vue&type=script&lang=js&"
import style0 from "./WidgetHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports